// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file configuracion_finca.proto (package sextante.configuracion.finca.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file configuracion_finca.proto.
 */
export const file_configuracion_finca: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Arboles a monitorear de una finca.
 *
 * @generated from message sextante.configuracion.finca.v1.GuardarArbolesRequest
 */
export type GuardarArbolesRequest = Message<"sextante.configuracion.finca.v1.GuardarArbolesRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Arboles que se revisan en cada monitoreo.
   *
   * @generated from field: int32 arboles_monitorear = 2;
   */
  arbolesMonitorear: number;
};

/**
 * Describes the message sextante.configuracion.finca.v1.GuardarArbolesRequest.
 * Use `create(GuardarArbolesRequestSchema)` to create a new message.
 */
export const GuardarArbolesRequestSchema: GenMessage<GuardarArbolesRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_finca, 0);

/**
 * Arboles sugeridos de un lote.
 * 
 * Un lote de 0,8 ha y uno de 12 ha no se recorren con la misma cantidad de arboles, y hasta ahora los
 * dos recibian el valor unico de la finca.
 *
 * @generated from message sextante.configuracion.finca.v1.GuardarArbolesLoteRequest
 */
export type GuardarArbolesLoteRequest = Message<"sextante.configuracion.finca.v1.GuardarArbolesLoteRequest"> & {
  /**
   * @generated from field: string lote_id = 1;
   */
  loteId: string;

  /**
   * Ausente = volver al calculo por area. NO es lo mismo que mandar 0.
   *
   * @generated from field: optional int32 arboles_sugeridos = 2;
   */
  arbolesSugeridos?: number | undefined;
};

/**
 * Describes the message sextante.configuracion.finca.v1.GuardarArbolesLoteRequest.
 * Use `create(GuardarArbolesLoteRequestSchema)` to create a new message.
 */
export const GuardarArbolesLoteRequestSchema: GenMessage<GuardarArbolesLoteRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_finca, 1);

/**
 * Lote con sus arboles sugeridos ya resueltos.
 *
 * @generated from message sextante.configuracion.finca.v1.GuardarArbolesLoteResponse
 */
export type GuardarArbolesLoteResponse = Message<"sextante.configuracion.finca.v1.GuardarArbolesLoteResponse"> & {
  /**
   * @generated from field: string lote_id = 1;
   */
  loteId: string;

  /**
   * Lo que quedo configurado a mano, si quedo algo.
   *
   * @generated from field: optional int32 arboles_sugeridos = 2;
   */
  arbolesSugeridos?: number | undefined;

  /**
   * Lo que sugiere la tabla por area para este lote. La pantalla lo muestra al lado, en gris, para
   * que se vea de que se esta apartando quien lo ajusta.
   *
   * @generated from field: int32 arboles_sugeridos_calculados = 3;
   */
  arbolesSugeridosCalculados: number;

  /**
   * El que de verdad se usa: el configurado si existe, si no el calculado.
   *
   * @generated from field: int32 arboles_sugeridos_efectivo = 4;
   */
  arbolesSugeridosEfectivo: number;
};

/**
 * Describes the message sextante.configuracion.finca.v1.GuardarArbolesLoteResponse.
 * Use `create(GuardarArbolesLoteResponseSchema)` to create a new message.
 */
export const GuardarArbolesLoteResponseSchema: GenMessage<GuardarArbolesLoteResponse> = /*@__PURE__*/
  messageDesc(file_configuracion_finca, 2);

/**
 * Valores optimos de ganaderia de una finca.
 *
 * @generated from message sextante.configuracion.finca.v1.GuardarGanaderiaRequest
 */
export type GuardarGanaderiaRequest = Message<"sextante.configuracion.finca.v1.GuardarGanaderiaRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Ganancia de peso diaria esperada por animal, en gramos.
   *
   * @generated from field: double ganaderia_crecimiento_diario_gr = 2;
   */
  ganaderiaCrecimientoDiarioGr: number;

  /**
   * Dias que conviene dejar descansar un potrero.
   *
   * @generated from field: int32 ganaderia_dias_descanso_optimo = 3;
   */
  ganaderiaDiasDescansoOptimo: number;

  /**
   * Dias que conviene tener los animales en un potrero.
   *
   * @generated from field: int32 ganaderia_dias_ocupacion_optimo = 4;
   */
  ganaderiaDiasOcupacionOptimo: number;

  /**
   * Carga animal recomendada, en animales por hectarea.
   *
   * @generated from field: double ganaderia_animales_x_hectarea_optimo = 5;
   */
  ganaderiaAnimalesXHectareaOptimo: number;
};

/**
 * Describes the message sextante.configuracion.finca.v1.GuardarGanaderiaRequest.
 * Use `create(GuardarGanaderiaRequestSchema)` to create a new message.
 */
export const GuardarGanaderiaRequestSchema: GenMessage<GuardarGanaderiaRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_finca, 3);

/**
 * Finca completa despues de guardar, para reemplazar la finca activa en la app.
 *
 * @generated from message sextante.configuracion.finca.v1.FincaConfiguracionItem
 */
export type FincaConfiguracionItem = Message<"sextante.configuracion.finca.v1.FincaConfiguracionItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string cliente_id = 2;
   */
  clienteId: string;

  /**
   * @generated from field: string nombre_finca = 3;
   */
  nombreFinca: string;

  /**
   * @generated from field: double hectareas_finca = 4;
   */
  hectareasFinca: number;

  /**
   * @generated from field: double hectareas_productivas = 5;
   */
  hectareasProductivas: number;

  /**
   * 0 = Agricultura, 1 = Ganaderia.
   *
   * @generated from field: int32 tipo_finca = 6;
   */
  tipoFinca: number;

  /**
   * WKB Point
   *
   * @generated from field: optional bytes ubicacion = 7;
   */
  ubicacion?: Uint8Array | undefined;

  /**
   * WKB Polygon
   *
   * @generated from field: optional bytes satelite_area_geografica = 8;
   */
  sateliteAreaGeografica?: Uint8Array | undefined;

  /**
   * @generated from field: optional string departamento_id = 9;
   */
  departamentoId?: string | undefined;

  /**
   * @generated from field: optional string departamento_nombre = 10;
   */
  departamentoNombre?: string | undefined;

  /**
   * @generated from field: optional string municipio_id = 11;
   */
  municipioId?: string | undefined;

  /**
   * @generated from field: optional string municipio_nombre = 12;
   */
  municipioNombre?: string | undefined;

  /**
   * @generated from field: optional string departamento_region_id = 13;
   */
  departamentoRegionId?: string | undefined;

  /**
   * @generated from field: optional string departamento_region_nombre = 14;
   */
  departamentoRegionNombre?: string | undefined;

  /**
   * @generated from field: double ganaderia_crecimiento_diario_gr = 15;
   */
  ganaderiaCrecimientoDiarioGr: number;

  /**
   * @generated from field: int32 ganaderia_dias_descanso_optimo = 16;
   */
  ganaderiaDiasDescansoOptimo: number;

  /**
   * @generated from field: int32 ganaderia_dias_ocupacion_optimo = 17;
   */
  ganaderiaDiasOcupacionOptimo: number;

  /**
   * @generated from field: double ganaderia_animales_x_hectarea_optimo = 18;
   */
  ganaderiaAnimalesXHectareaOptimo: number;

  /**
   * @generated from field: int32 arboles_monitorear = 19;
   */
  arbolesMonitorear: number;

  /**
   * URL de los tiles del ortomosaico de la finca, si ya se proceso.
   *
   * @generated from field: optional string uri_ortomosaico = 20;
   */
  uriOrtomosaico?: string | undefined;

  /**
   * Plantilla de URL de los tiles del conteo de animales, si existe.
   *
   * @generated from field: optional string conteo_pre_render = 21;
   */
  conteoPreRender?: string | undefined;

  /**
   * Ultimo paso del registro de la finca que se completo. No dice si la finca esta completa: eso es tener
   * area y al menos un lote.
   *
   * @generated from field: int32 paso_registro_completado = 22;
   */
  pasoRegistroCompletado: number;
};

/**
 * Describes the message sextante.configuracion.finca.v1.FincaConfiguracionItem.
 * Use `create(FincaConfiguracionItemSchema)` to create a new message.
 */
export const FincaConfiguracionItemSchema: GenMessage<FincaConfiguracionItem> = /*@__PURE__*/
  messageDesc(file_configuracion_finca, 4);

/**
 * Migracion a gRPC-Web de la configuracion de arboles a monitorear y de ganaderia de la finca (ver
 * CLAUDE.md, seccion migracion a gRPC-Web). Logica propia -no reusa IFincaArbolesService/
 * IFincaGanaderiaService/Services.Implementations-, mismo criterio que ClienteFincaWizardGrpcService/
 * LoginGrpcService: consulta y actualiza ClienteFincaModel directo via IPlataformaDataContextExecutor.
 * 
 * FincaConfiguracionItem repite el mismo set de campos que login.proto Finca (menos "lotes"): es la
 * forma que ya espera FincaParaGuardar/upsertFincaAsync del lado cliente (ver GrpcFincaLoteDatabase.ts),
 * asi que ninguno de los dos guardados necesita mas que eso para reemplazar la finca activa completa.
 * Se duplica el mensaje en vez de importar login.proto -mismo criterio que terceros_finca_wizard.proto
 * (GuardarResponse), cada .proto de este proyecto es autocontenido.
 * 
 * Nombres verificados contra "grep -rn '^message ' Api/Protos/*.proto" antes de escribirlos (namespace
 * csharp compartido entre todos los .proto: choque = CS0102/CS0111/CS8646).
 * 
 * Pertenencia (2026-09-30): solo trabaja con datos de fincas del cliente de la sesion. Una finca, lote o
 * registro de otro cliente responde NotFound, igual que uno inexistente. NombreFinca y ClienteId salen de
 * la relacion de ese cliente con la finca. Antes no se validaba: cualquier sesion podia reconfigurar
 * cualquier finca por id.
 *
 * @generated from service sextante.configuracion.finca.v1.ConfiguracionFincaService
 */
export const ConfiguracionFincaService: GenService<{
  /**
   * Guarda cuantos arboles se monitorean en la finca. Devuelve la finca completa.
   * 
   * OBSOLETO desde 2026-10-19: los arboles sugeridos pasaron a ser por lote (GuardarArbolesLote). Se
   * mantiene mientras la App vieja lo use; sigue propagando el valor a todos los lotes.
   *
   * @generated from rpc sextante.configuracion.finca.v1.ConfiguracionFincaService.GuardarArboles
   */
  guardarArboles: {
    methodKind: "unary";
    input: typeof GuardarArbolesRequestSchema;
    output: typeof FincaConfiguracionItemSchema;
  },
  /**
   * Ajusta los arboles sugeridos de UN lote. Mandar el campo ausente = volver al calculo por area.
   *
   * @generated from rpc sextante.configuracion.finca.v1.ConfiguracionFincaService.GuardarArbolesLote
   */
  guardarArbolesLote: {
    methodKind: "unary";
    input: typeof GuardarArbolesLoteRequestSchema;
    output: typeof GuardarArbolesLoteResponseSchema;
  },
  /**
   * Guarda los valores optimos de ganaderia de la finca. Devuelve la finca completa.
   *
   * @generated from rpc sextante.configuracion.finca.v1.ConfiguracionFincaService.GuardarGanaderia
   */
  guardarGanaderia: {
    methodKind: "unary";
    input: typeof GuardarGanaderiaRequestSchema;
    output: typeof FincaConfiguracionItemSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_configuracion_finca, 0);

